function parseColor(color) {
    const ctx = document.createElement("canvas").getContext("2d");
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, 1, 1);
    const rgb = ctx.getImageData(0, 0, 1, 1).data;
    return [rgb[0] / 255, rgb[1] / 255, rgb[2] / 255];
}

function getLuminance([r, g, b]) {
    const gammaCorrect = (c) =>
        c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    return 0.2126 * gammaCorrect(r) + 0.7152 * gammaCorrect(g) + 0.0722 * gammaCorrect(b);
}

export function getContrastingTextColor(backgroundColor) {
    const rgb = parseColor(backgroundColor);
    const luminance = getLuminance(rgb);
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
}
